export default __webpack_public_path__ + "imgs/scratch_scale_item_update.png";